<template>
    <div class="orderBox">
        <el-tabs v-model="orderName" @tab-click="handleClick">
            <el-tab-pane label="我发起的" name="first">
                <Iinitiated v-if="orderName === 'first'"></Iinitiated>
            </el-tab-pane>
            <el-tab-pane label="我支付的" name="second">
                <Ipaid v-if="orderName === 'second'"></Ipaid>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import Iinitiated from './components/Iinitiated';
    import Ipaid from './components/Ipaid';

    export default {
        name: 'orderList',
        data(){
            return{
                orderName:'first'
            }
        },
        components:{
            Iinitiated,
            Ipaid
        },
        methods:{
            handleClick(tab, event){
                sessionStorage.setItem('orderTab', tab.name)
            }
        },
        created() {
            let name = sessionStorage.getItem('orderTab')
            // 判断是否存在currentTab，即tab页之前是否被点击切换到别的页面
            if(name){
                this.orderName = name
            }
        },
    };
</script>

<style scoped>
    .orderBox{
        padding: 20px;
        background-color: #fff;
        border-radius: 5px;
    }
    /deep/ .el-tabs__nav-wrap::after{
        background-color: transparent;
    }
    /deep/.el-tabs__item{
        padding: 0px 30px;
    }
</style>
